import {LocalizationContainer} from "./LocalizationContainer.js";
import {WelcomeTextContainer} from "./WelcomeTextContainer";
import {CategoriesNavigation} from "./CategoriesNavigation.js";
import {MenuItemsList} from "./MenuItemsList";
import {Footer} from "./footer/Footer.tsx";

export const Menu = () => {

    return (
        <div>
            <LocalizationContainer/>
            <WelcomeTextContainer/>
            <CategoriesNavigation/>
            <MenuItemsList/>
            <Footer/>
        </div>
    );
}
